import { labelTypeConstants } from "../../constants";
import { labelTypeService } from "../../services";
import { alertActions } from "../alert.actions";

export const labelTypeActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    labelTypeService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: labelTypeConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: labelTypeConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: labelTypeConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code,labelType,handleSuccessDialog,successMsg) {
  return (dispatch) => {
    dispatch(request(name, code));

    labelTypeService.addParameter(name, code,labelType).then(
      (parameter) => {
        handleSuccessDialog(successMsg);
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: labelTypeConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: labelTypeConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: labelTypeConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code) {
  return (dispatch) => {
    dispatch(request(id, name, code));

    labelTypeService.updateParameter(id, name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: labelTypeConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: labelTypeConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: labelTypeConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    labelTypeService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: labelTypeConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: labelTypeConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: labelTypeConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: labelTypeConstants.CLEAR };
}
